export const Checkbox = {
  parts: ['container', 'icon', 'control', 'label'],
  baseStyle: {
    control: {
      _disabled: {
        borderColor: 'blackAlpha.200',
        bg: 'transparent',
      },
      _checked: {
        _disabled: {
          borderColor: 'blackAlpha.200',
          bg: 'transparent',
        },
        _hover: {
          borderColor: 'blackAlpha.500',
          bg: 'blackAlpha.500',
        },
        borderColor: 'black',
        bg: 'black',
      },
    },
    container: {
      w: 'full',
      alignItems: 'flex-start',
    },
  },
  sizes: {
    lg: {
      label: { fontSize: 'sm' },
      icon: { fontSize: 'xs' },
    },
    md: {
      label: { fontSize: 'xs' },
      icon: { fontSize: '2xs' },
    },
    sm: {
      label: { fontSize: 'xs' },
      icon: { fontSize: '2xs' },
    },
    xs: {
      label: { fontSize: 'xs' },
      icon: { fontSize: '3xs' },
    },
  },
  defaultProps: {
    size: 'md',
  },
};
